<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<onboarding-container [hideBack]="true" [hideForward]="true">
  <p class="zero-text p-huge-med">{{ 'onboarding.in-progress.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.in-progress.text' | transloco }}</p>
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-start gap">
    <div class="zero-surface grey-800 py-4 px-3 b-r-8 w-one-third">
      <div class="investment-card d-flex flex-column justify-content-between">
        <div class="d-flex flex-column align-items-center pt-4">
          <web-design-system-icon name="pig" size="large" class="d-block mb-2" />
          <div class="zero-text p-big-med text-center mb-1 px-3">{{ 'onboarding.in-progress.card.pig.headline' | transloco }}</div>
          <div class="zero-text p-xsmall-reg label text-center">{{ 'onboarding.in-progress.card.pig.text' | transloco }}</div>
        </div>
        <div class="w-100">
          <web-design-system-button class="d-block mb-3" size="small" [fullwidth]="true" [routerLink]="savingsPlan">{{
            'onboarding.in-progress.card.pig.btn' | transloco
          }}</web-design-system-button>
        </div>
      </div>
      <div class="text-center">
        @if (!toggledMoreInformationItems().includes(savingsPlan)) {
          <a class="zero-text link p-xsmall-reg" (click)="toggleMoreInformation(savingsPlan)"
            >{{ 'onboarding.in-progress.link' | transloco }}
            <web-design-system-icon size="small" name="chevron-2" />
          </a>
        } @else {
          <div>
            <web-design-system-icon name="pig" class="d-block mb-2" />
            <div class="zero-text p-xsmall-reg label text-center mb-2">
              {{ 'onboarding.in-progress.card.pig.more-information.1' | transloco }}
            </div>
            <web-design-system-icon name="warren-buffet" class="d-block mb-2" />
            <div class="zero-text p-xsmall-reg label text-center mb-2">
              {{ 'onboarding.in-progress.card.pig.more-information.2' | transloco }}
            </div>
            <web-design-system-icon name="arrow-box" class="d-block mb-2" />
            <div class="zero-text p-xsmall-reg label text-center mb-2">
              {{ 'onboarding.in-progress.card.pig.more-information.3' | transloco }}
            </div>
            <a class="zero-text link p-xsmall-reg" (click)="toggleMoreInformation(savingsPlan)"
              >{{ 'onboarding.in-progress.close' | transloco }}
              <web-design-system-icon size="small" name="chevron" />
            </a>
          </div>
        }
      </div>
    </div>
    <div class="badge-wrapper zero-surface grey-800 py-4 px-3 b-r-8 w-one-third">
      <div class="special-badge zero-surface pink-400 text-center px-5 py-1">
        <div class="special-badge-text">{{ 'onboarding.in-progress.card.chess.special-badge' | transloco }}</div>
      </div>
      <div class="investment-card d-flex flex-column justify-content-between">
        <div class="d-flex flex-column align-items-center pt-4">
          <web-design-system-icon name="chess" size="large" class="d-block mb-2" />
          <div class="zero-text p-big-med text-center mb-1">{{ 'onboarding.in-progress.card.chess.headline' | transloco }}</div>
          <div class="zero-text p-xsmall-reg label text-center">{{ 'onboarding.in-progress.card.chess.text' | transloco }}</div>
        </div>
        <div class="w-100">
          <web-design-system-button class="d-block mb-3" size="small" [fullwidth]="true" [routerLink]="investmentStrategy">{{
            'onboarding.in-progress.card.chess.btn' | transloco
          }}</web-design-system-button>
        </div>
      </div>
      <div class="text-center">
        @if (!toggledMoreInformationItems().includes(investmentStrategy)) {
          <a class="zero-text link p-xsmall-reg" (click)="toggleMoreInformation(investmentStrategy)"
            >{{ 'onboarding.in-progress.link' | transloco }}
            <web-design-system-icon size="small" name="chevron-2" />
          </a>
        } @else {
          <div>
            <web-design-system-icon name="thumb" class="d-block mb-2" />
            <div
              class="zero-text p-xsmall-reg label text-center mb-2"
              [innerHTML]="'onboarding.in-progress.card.chess.more-information.1' | transloco"
            ></div>
            <web-design-system-icon name="flipflop" class="d-block mb-2" />
            <div
              class="zero-text p-xsmall-reg label text-center mb-2"
              [innerHTML]="'onboarding.in-progress.card.chess.more-information.2' | transloco"
            ></div>
            <web-design-system-icon name="user" class="d-block mb-2" />
            <div
              class="zero-text p-xsmall-reg label text-center mb-2"
              [innerHTML]="'onboarding.in-progress.card.chess.more-information.3' | transloco"
            ></div>
            <a class="zero-text link p-xsmall-reg" (click)="toggleMoreInformation(investmentStrategy)"
              >{{ 'onboarding.in-progress.close' | transloco }}
              <web-design-system-icon size="small" name="chevron" />
            </a>
          </div>
        }
      </div>
    </div>
    <div class="zero-surface grey-800 py-4 px-3 b-r-8 w-one-third">
      <div class="investment-card d-flex flex-column justify-content-between">
        <div class="d-flex flex-column align-items-center pt-4">
          <web-design-system-icon name="user" size="large" class="d-block mb-2" />
          <div class="zero-text p-big-med text-center mb-1 px-3">{{ 'onboarding.in-progress.card.arrows.headline' | transloco }}</div>
          <div class="zero-text p-xsmall-reg label text-center">{{ 'onboarding.in-progress.card.arrows.text' | transloco }}</div>
        </div>
        <div class="w-100">
          <web-design-system-button class="d-block mb-3" size="small" [fullwidth]="true" [routerLink]="depot">{{
            'onboarding.in-progress.card.arrows.btn' | transloco
          }}</web-design-system-button>
        </div>
      </div>
      <div class="text-center">
        @if (!toggledMoreInformationItems().includes(depot)) {
          <a class="zero-text link p-xsmall-reg" (click)="toggleMoreInformation(depot)"
            >{{ 'onboarding.in-progress.link' | transloco }}
            <web-design-system-icon size="small" name="chevron-2" />
          </a>
        } @else {
          <div>
            <web-design-system-icon name="setting-slider" class="d-block mb-2" />
            <div class="zero-text p-xsmall-reg label text-center mb-2">
              {{ 'onboarding.in-progress.card.arrows.more-information.1' | transloco }}
            </div>
            <web-design-system-icon name="globe" class="d-block mb-2" />
            <div class="zero-text p-xsmall-reg label text-center mb-2">
              {{ 'onboarding.in-progress.card.arrows.more-information.2' | transloco }}
            </div>
            <web-design-system-icon name="chess" class="d-block mb-2" />
            <div class="zero-text p-xsmall-reg label text-center mb-2">
              {{ 'onboarding.in-progress.card.arrows.more-information.3' | transloco }}
            </div>
            <a class="zero-text link p-xsmall-reg" (click)="toggleMoreInformation(depot)"
              >{{ 'onboarding.in-progress.close' | transloco }}
              <web-design-system-icon size="small" name="chevron" />
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</onboarding-container>
